function appendRequestID(errorMsg: string, response: Response, headerKey = "x-amzn-requestid"): string {
    const requestId = response.headers.get(headerKey) ?? "";
    return errorMsg + ` (RequestId: ${requestId})`;
}

export { appendRequestID };
